function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 15
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Repeat_Grid_7",
  "data-name": "Repeat Grid 7",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-294 -240)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-289 -240)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-2",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-284 -240)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-3",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-294 -236)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-4",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-289 -236)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-5",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-284 -236)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-6",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-294 -232)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-7",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-289 -232)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-8",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-284 -232)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-9",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-294 -228)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-10",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-289 -228)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-11",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-284 -228)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_197-12",
  "data-name": "Rectangle 197",
  width: 2,
  height: 2,
  rx: 1,
  transform: "translate(294 240)",
  fill: "#7f7f7f"
})));

function SvgIconHabitGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHabitGrid);
export default ForwardRef;